module.exports = __webpack_public_path__ + "img/business_02.32a9a2c8.png";